import { axiosSwagger } from "@/axios";

export const state = {
    deliveryUnit: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // DELIVERY UNIT
    deliveryUnitLoading: (state, loading) => {
        state.deliveryUnit.loading = loading;
    },
    setDeliveryUnitData: (state, data) => {
        state.deliveryUnit.data = data;
    },
    setDeliveryUnitTotal: (state, total) => {
        state.deliveryUnit.total = total;
    },
}


export const actions = {
    // GET ALL DELIVERY UNIT
    async readDeliveryUnit({ commit }) {
        commit("deliveryUnitLoading", true);

        return await axiosSwagger
        .get("/api/DeliveryUnit/All")
        .then((response) => {
            commit("setDeliveryUnitData", response.data);
            commit("setDeliveryUnitTotal", response.data.length);
            commit("DeliveryUnitLoading", false);

            return response;
        })
        .catch(() => {
            commit("deliveryUnitLoading", false);
        });
    },
    // GET DELIVERY BY OFFICE ID
    async readDeliveryUnitByOfficeId({ commit }, id) {
        commit("deliveryUnitLoading", true);

        return await axiosSwagger
        .get(`/api/DeliveryUnit/Office/${id}`)
        .then((response) => {
            commit("deliveryUnitLoading", false);
            return response;
        })
        .catch(() => {
            commit("deliveryUnitLoading", false);
        });
    },
    // GET DELIVERY UNIT BY ID
    // eslint-disable-next-line no-unused-vars
    async readDeliveryUnitById({ commit }, id){
        return await axiosSwagger
        .get(`/api/DeliveryUnit/${id}`)
        .then((response) => {

            return response;
        });
    },
}